import { useState } from "react"
import { useRenterDashboardContext } from "../renter-dashboard/useRenterDashboardContext"
import ModalEditPayments from "../modals/fields/EditPayments/modals/ModalEditPayments";
import { PAYMENT_STATUS, PaymentInfo } from "../../../../types/payment.type";
import "./PaymentsTable.block.scss"
import { ModalFine } from "../modals/fields/EditPayments/modals/ModalFine"
import { ModalProRata } from "./ModalProRata"
import ModalDeletePayments from "../modals/fields/EditPayments/modals/ModalDeletePayments";
import { RxOpenInNewWindow } from "react-icons/rx"
import { ModalContractFine } from "../modals/fields/EditPayments/modals/ModalContractFine";
import { ReactivationNegotiationModal } from "../modals/fields/EditPayments/modals/ReactivationNegotiationModal";
import ModalConvertDeposit from "../modals/fields/EditPayments/modals/ModalConvertDeposit";
import Permission from "../../../../common/components/auth/Permission";
import ModalRestorePayments from "../modals/fields/EditPayments/modals/ModalRestorePayments"
import { TablePaymentsPreview } from "../payments/TablePaymentsPreview"
import { TablePayments } from "../payments/TablePayments"
import { RadioButtonPaymentsFilter } from "../payments/RadioButtonPaymentsFilter";
import { usePaymentsTable } from "../customHook/usePaymentsTable";
import { getStatusLabelsPayment, withInactiveStyle } from "../payments/paymentUtils";
import { TABLE_HEADERS } from "../constants/paymentConstants";
import { PaymentActionButtons } from "../payments/PaymentActionButtons";
import { useNavigate } from "react-router-dom";


const EMPTY_ACTION = { eventName: '', data: undefined };

export function PaymentsTable() {
  const { renter } = useRenterDashboardContext()
  const navigate = useNavigate();
  const [openModalProRata, setOpenModalProRata] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openReactivationNegotiation, setReactivationNegotiationModal] = useState(false);
  const [billindModal, setBillingModal] = useState(false);
  const [action, setAction] = useState<{ eventName: string, data?: unknown }>(EMPTY_ACTION);
  const {
    payments,
    showFines,
    isLoading,
    statusFilter,
    modalPayment,
    setModalPayment,
    handleStatusChange,
    handleShowFines,
    handleSyncAsaas,
  } = usePaymentsTable();


  const isCaucaoPayment = (data: PaymentInfo): boolean => {
    const planId = data.planId || ''; // Valor padrão como string vazia se for null/undefined
    // Retorna true somente se o planId NÃO começar com "caucao-facilitado-"
    return !planId.startsWith('caucao-facilitado-');
  };

  const actions = [
    {
      label: "Editar Fatura",
      visible: (data) => {
        if (!data.planId) return true;
        return !(/(caucao-facilitado|trafficfine|multa-de-transito|negotiationfine)/.test(data.planId));
      },
      action: (data) => setAction({ eventName: 'editBilling', data }),
      disabled: (data) =>
        !isCaucaoPayment(data) ||
        data.status === 'Inativo' ||
        data.status === 'RECEIVED',
      role: "finance"

      // permission: "editBilling:payment",
    },
    {
      label: "Remover Fatura",
      visible: (data) => {
        if (!data.planId) return true;
        return !(/(caucao-facilitado|negotiationfine)/.test(data.planId));
      },
      action: (data) => setAction({ eventName: 'deleteBilling', data: data._id }),
      disabled: (data) =>
        !isCaucaoPayment(data) ||
        data.status === PAYMENT_STATUS.Inativo ||
        data.status === PAYMENT_STATUS.RECEIVED,
      permission: "delete:payment",
      // role: "finance"

    },
    {
      label: "Restaurar Fatura",
      visible: (data) => {
        if (!data.planId) return true;
        return !(/(caucao-facilitado|negotiationfine)/.test(data.planId));
      },
      action: (data) => setAction({ eventName: 'restoreBilling', data: data._id }),
      disabled: (data) =>
        !isCaucaoPayment(data) ||
        data.status != PAYMENT_STATUS.Inativo,
      role: "finance"
      // permission: "deleteBilling:payment",

    },
    {
      label: "Parcelar Semanal",
      visible: (data) => {
        const description = (data as { description: string }).description;
        return /PLANO SV|SUA VIBE/.test(description)
      },
      action: (data) => setAction({ eventName: 'installmentsWeek', data: (data as PaymentInfo) }),
      disabled: (data) => {
        const description = (data as { description: string }).description;
        const desactive = /VIBE FACTOR/.test(description) || /CAUÇÃO/.test(description)
        return desactive;
      },
      // permission: "deleteBilling:payment",
      // permission: "installmentsWeek:payment",
      role: "finance"

    },
    {
      label: "Converter caução",
      visible: (data) => {
        if (!data.planId) return false;
        return /^(caucao|caucao-facilitado)$/.test(data.planId);
      },
      action: (data) => setAction({ eventName: 'convertDeposit', data: (data as PaymentInfo) }),
      disabled: (data) => data.status !== PAYMENT_STATUS.PENDING,
      // permission: "deleteBilling:payment",
      // permission: "convertDeposit:payment",
      role: "finance"
    },
  ];

  const isAction = (eventName: string) => action.eventName === eventName;

  const cleanActionData = () => {
    setAction(EMPTY_ACTION);
  };

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">

        <section>
          {billindModal && (
            <ModalContractFine onClosed={() => setBillingModal(false)} open={billindModal} />
          )
          }
          {openModal && (
            <ModalFine trafficFines={payments} onClosed={() => setOpenModal(false)} open={openModal}></ModalFine>
          )}
          {
            openReactivationNegotiation && (
              < ReactivationNegotiationModal
                onClosed={() => setReactivationNegotiationModal(false)}
                open={openReactivationNegotiation}
                payments={payments}
                renter={renter}
              />
            )}
          <Permission role="finance">
            <ModalProRata
              payments={payments.filter(
                payment =>
                  (payment.status === PAYMENT_STATUS.PENDING || payment.status === PAYMENT_STATUS.OVERDUE) &&
                  /COBRANÇA REFERENTE A SEMANAL DO PLANO/.test(payment.description)
              )}
              onClosed={() => setOpenModalProRata(false)}
              open={openModalProRata}
            />
          </Permission>
          <div id="top-table-payments" className="flex flex-col sm:flex-row justify-between items-center gap-y-4 sm:gap-x-4">
            {/* Título e Ícone */}
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
              <RxOpenInNewWindow
                className="payment-open-modal cursor-pointer"
                onClick={() => setModalPayment(true)}
                title="Expandir tabela para visualizar"
              />

              <PaymentActionButtons
                isLoading={isLoading}
                showFines={showFines}
                renter={renter}
                onSyncAsaas={handleSyncAsaas}
                onOpenProRata={() => setOpenModalProRata(true)}
                onOpenBilling={() => setBillingModal(true)}
                onOpenReactivation={() => setReactivationNegotiationModal(true)}
                onOpenFines={() => setOpenModal(true)}
                onOpenDebts={() => navigate(`/clientes/${renter._id}/debitos`)}
              />
            </div>
          </div>
        </section>

        <div className="flex justify-center flex-1">
          <RadioButtonPaymentsFilter
            statusFilter={statusFilter}
            showFines={showFines}
            handleStatusChange={handleStatusChange}
            handleShowFines={handleShowFines}
          />
        </div>

        <TablePaymentsPreview
          modalPayment={modalPayment}
          setModalPayment={setModalPayment}
          payments={payments as unknown as Record<string, unknown>[]}
          withInactiveStyle={withInactiveStyle}
          getStatusLabels={getStatusLabelsPayment}
        />

        <TablePayments
          payments={payments as unknown as Record<string, unknown>[]}
          actions={actions}
          renter={renter}
          tableHeaders={TABLE_HEADERS}
          withInactiveStyle={withInactiveStyle}
          getStatusLabels={getStatusLabelsPayment}
        />
      </section >

      {isAction('editBilling') && <ModalEditPayments renterName={renter.name} action={"editBilling"} renterId={renter._id!} payments={payments} data={action.data as PaymentInfo} billingId={action.data as { _id: string }} onClose={cleanActionData} />}
      {isAction('installmentsWeek') && <ModalEditPayments renterName={renter.name} action={"installmentsWeek"} renterId={renter._id!} payments={payments} data={action.data as PaymentInfo} billingId={action.data as { _id: string }} onClose={cleanActionData} />}
      {isAction('deleteBilling') && <ModalDeletePayments paymentId={(action.data as string)} renterId={renter._id!} onClose={cleanActionData} />}
      {isAction('restoreBilling') && <ModalRestorePayments paymentId={(action.data as string)} renterId={renter._id!} onClose={cleanActionData} />}
      {isAction('convertDeposit') && <ModalConvertDeposit payments={payments} renterId={renter._id!} onClose={cleanActionData} />}
    </div >
  );
}